import React from "react";
import Modal from "../../ui-components/Modal";
import _ from "lodash";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import AuthenticationService from "../../services/AuthenticationService";
import { useEffect, useState, useContext } from "react";
import apiRequest from "@services/apiRequest";
import Spinner from "../../ui-components/Spinner";

export const ConnectionsWorksiteModal = ({
   showWorksites,
   setShowWorksites,
   worksiteTypes,
   countryCode,
   intl,
  visibilityUserIds,
  visibilityLevel,
 }) => {
  const userData = AuthenticationService.getUserData();
  const lkpType = worksiteTypes.reduce(
    (obj, i) => _.set(obj, [i.cod_worksite_type], i["icon_name"]),
    {}
  );
  const [worksites, setWorksites] = useState([]);

  useEffect(() => {
    if (!showWorksites) return;
    const fetchUserWorksites = async () => {
      try {
        const response = await apiRequest.post('/analytics/retrieve_user_worksites_or_surveys', {
          country: countryCode,
          user_id: showWorksites.id,
          ownership: showWorksites.ownership,
          visibility_user_ids: visibilityUserIds,
          retrieve_type: 'worksites'
        })
        setWorksites(response);
      } catch (error) {
        console.log("errore", error);
      }
    }
    fetchUserWorksites()
  }, []);

  return (
    <Modal onExit={() => setShowWorksites(undefined)}>
      <div className="flex w-full flex-col h-full">
        <label className="block text-lg font-bold mb-3">
          {intl.formatMessage({ id: "worksites" })}
        </label>
        {worksites && worksites.length > 0 ? worksites.map((i) => (
          <div className="grid grid-cols-6 my-2" key={i.id}>
            <div
              className="w-16 h-16 mb-2 bg-contain bg-center relative bg-no-repeat"
              style={{
                backgroundImage: `url(${lkpType[i.cod_worksite_type]})`,
                height: "40px",
                width: "40px",
              }}
            />
            <div className="col-span-4 capitalize">
              <span>{i.address} </span>
              <br />
              <span className="italic text-sm">
                {i.city} ({i.cod_province})
              </span>
            </div>
            <div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`/${countryCode}/worksites/${i.id}`}
              >
                <ArrowTopRightOnSquareIcon
                  className={`w-6 h-6 mt-2 text-${userData.business}-400 cursor-pointer`}
                />
              </a>
            </div>
          </div>
        )): <div className={"flex flex-row items-center"}><Spinner styleType={"white"}/></div>}
      </div>
    </Modal>
  );
}
